import { render, staticRenderFns } from "./brandCenter.vue?vue&type=template&id=10f323ea&scoped=true&"
import script from "./brandCenter.vue?vue&type=script&lang=js&"
export * from "./brandCenter.vue?vue&type=script&lang=js&"
import style0 from "./brandCenter.vue?vue&type=style&index=0&id=10f323ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f323ea",
  null
  
)

export default component.exports